export default __webpack_public_path__ + "static/dont-animate-too-many-d6818724d3d34f9f902bc0d4e2b0b10ba37533cae46628e47f0339dba805ab13.png";